import React from 'react'
import { selectReports } from './selectors'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  ResponsiveContainer,
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ReferenceLine,
  Tooltip
} from 'recharts'
import Unit from 'components/Unit'

const BAR_SIZE = 40

const percentageFormatter = val => `${(val * 100).toFixed(2)} %`

const ChartTooltip = ({ payload }) => {
  if (!payload || !payload[0]) {
    return null
  }

  const { profile, scrapPercentage, goodLength, scrapLength } = payload[0].payload

  return (
    <div className='report-graph-tooltip' style={{ minWidth: 350 }}>
      <div className='report-graph-tooltip__content'>
        <h4 className='report-graph-tooltip__header'>
          {profile}
        </h4>
      </div>
      <div className='report-graph-tooltip__footer'>
        <div style={{ display: 'flex' }}>
          <div className='recharts-custom-tooltip__label'>
            <FormattedMessage id='reports.monthlyEvaluation.goodLength' />
            &nbsp;
          </div>
          <div className='recharts-custom-tooltip__value'>
            <Unit value={goodLength / 1000.0} unit='meter' />
          </div>
        </div>
        <br />
        <div style={{ display: 'flex' }}>
          <div className='recharts-custom-tooltip__label'>
            <FormattedMessage id='reports.monthlyEvaluation.scrapLength' />
            &nbsp;
          </div>
          <div className='recharts-custom-tooltip__value'>
            <Unit value={scrapLength / 1000.0} unit='meter' />
          </div>
        </div>
        <br />
        <div style={{ display: 'flex' }}>
          <div className='recharts-custom-tooltip__label'>
            <FormattedMessage id='reports.monthlyEvaluation.scrapPercentage' />
            &nbsp;
          </div>
          <div className='recharts-custom-tooltip__value'>
            {percentageFormatter(scrapPercentage)}
          </div>
        </div>
      </div>
    </div>
  )
}

ChartTooltip.propTypes = {
  payload: PropTypes.array
}

const MonthlyEvaluationReportChart = ({ data }) => {
  console.log('Chart renders', data)

  return (
    <div
      style={{ width: '100%', height: 500, marginTop: 18, marginBottom: 18 }}
    >
      <ResponsiveContainer>
        <ComposedChart
          syncId='tpm'
          width={600}
          height={600}
          data={data}
          margin={{
            top: 20,
            right: 20,
            bottom: 120,
            left: 20
          }}
          barGap={0}
        >
          <CartesianGrid stroke='#f5f5f5' />
          <ReferenceLine y={0} stroke='#000' />
          <XAxis
            dataKey='profile'
          />
          <YAxis dataKey='scrapPercentage' domain={[0, 1]} tickFormatter={percentageFormatter} />
          <Bar dataKey='scrapPercentage' barSize={BAR_SIZE} fill='#FFB1A1' />
          <Tooltip content={<ChartTooltip />} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  )
}

MonthlyEvaluationReportChart.propTypes = {
  data: PropTypes.array
}

const mapStateToProps = (state) => ({
  data: selectReports(state)
})

export default connect(mapStateToProps)(MonthlyEvaluationReportChart)
